import { defineMessages } from 'react-intl';
import { isBlank } from 'helpers/verify';

const messages = defineMessages({
  minimumFieldLength: {
    id: 'validators.length.tooShort',
    defaultMessage: 'Field must be at least {minLength} characters long.',
  },
});

export const minLengthValidator = (minLength, val) => {
  const str = `${val}`.trim();

  if (isBlank(str) || str.length < minLength) {
    return {
      ...messages.minimumFieldLength,
      values: {
        minLength,
      },
    };
  }
};
